import styled from 'styled-components'

import colors from '../color'

export default styled.input`
  width: 100%;
  padding: 15px;
  font-size: 16px;
  border: 1px solid ${colors.gray};
  box-sizing: border-box;
`
